window.getArticleTemplate = (article) => {
    return `
    <a href="${article.guid}" title="${article.post_title}" target="_blank">
        <img
            class="article-img"
            src="${article.image?.length > 0 ? article.image : '/wp-content/themes/lostintheusa/dist/images/default-roadtrip-thumb.jpg'}"
            alt="${article.post_title}"
        />
        <div class="article-text">${article.post_title}</div>
    </a>
    `;
}